import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirect } from "@/lib/legacy-redirect";

export const Route = createFileRoute("/louisville-ky/")({
  beforeLoad: () => legacyRedirect("/service-area/louisville-ky"),
});
